"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyFormDialog = CompanyFormDialog;
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _OpenInNew2 = _interopRequireDefault(require("@mui/icons-material/OpenInNew"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _environment = require("../../environment");
var _services = require("../../services");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CompanyFormDialog(_ref) {
  let {
    Dialog,
    Button,
    currentUser,
    onClose,
    ...props
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose()
  }, props), /*#__PURE__*/_react.default.createElement(_DialogTitle2.default, null, t('commons.communities.company_dialog.title')), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, null, t('commons.communities.company_dialog.description'))), /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, /*#__PURE__*/_react.default.createElement(Button, {
    onClick: () => onClose(),
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    component: "a",
    endIcon: /*#__PURE__*/_react.default.createElement(_OpenInNew2.default, null),
    href: `${_environment.defaultEnvironment.enterpriseUrl}subscription/connect?auth-token=${_services.HttpService.authorizationToken?.substring(_services.HttpService.authorizationToken.indexOf(' ') + 1)}&user-id=${currentUser?.id}`,
    rel: "noreferrer",
    target: "_blank",
    variant: "contained"
  }, t('commons.communities.company_dialog.actions.create_company'))));
}